import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const billingUrl = { baseURL: environment.get().api.billingURL };
const billingEndpoint = appconfig.endpoints.billingAccountMe;

export const daoBillingMeGet = () => api.get(billingEndpoint, billingUrl);

